<div class="flex min-h-screen bg-surface text-stone-900 font-sans antialiased relative">
  <!-- Dedicated Sidebar Component -->
  <app-sidebar
    [(isOpen)]="isMobileSidebarOpen"
    [customerName]="customerName()"
    [imageUrl]="imageUrl()"
    [defaultImage]="defaultImage"
    [customers]="customers()"
    [isJubooAgent]="isJubooAgent"
    [selectedCustomer]="selectedCustomer"
    (customerSelected)="selectCustomer($event)"
  ></app-sidebar>

  <!-- Main Content Area (Header + Page Content) -->
  <div class="flex-1 flex flex-col min-w-0">
    <!-- Top Header Component -->
    <app-header
      [currentUser]="currentUser"
      [customerName]="customerName()"
      [customerLogo]="imageUrl()"
      (toggleMobileSidebar)="toggleMobileSidebar()"
      (logoutRequested)="openLogoutModal()"
    ></app-header>

    <!-- Page Content Container -->
    <main class="flex-1 px-4 sm:px-6 lg:px-8 py-6 max-w-[1600px] w-full mx-auto">
      <router-outlet></router-outlet>
    </main>
  </div>

  <!-- Logout Confirmation Modal -->
  <app-confirm-modal
    [isOpen]="showLogoutModal"
    title="CONFIRM_MODAL.LOGOUT_TITLE"
    message="CONFIRM_MODAL.LOGOUT_MESSAGE"
    confirmLabel="CONFIRM_MODAL.LOGOUT_CONFIRM"
    variant="danger"
    (confirmed)="confirmLogout()"
    (cancelled)="closeLogoutModal()"
  ></app-confirm-modal>
</div>
